import PageHeader from '@shared/components/core/headers/PageHeader';
import ExploreProductsCard from '@shared/components/products/ExploreProductsCard';
import { useTranslation } from 'react-i18next';

export default function LicenseUpgradePage() {
    const { t } = useTranslation();

    return (
        <>
            <PageHeader
                title={t('common:billing.upgrade.compare')}
                description={t('common:billing.upgrade.description')}
            />
            <ExploreProductsCard />
        </>
    );
}
